import styled, {css} from 'styled-components';

import {ContentContainer} from 'components/ui-kit/PageComponents';
import {colors} from 'theme';

export const ContentWrapper = styled(ContentContainer)``;

export const FormWrapper = styled.div`
    padding-bottom: 50px;
`;

export const FormField = styled.div`
    margin-bottom: 15px;
`;

export const FormContainer = styled.div`
    padding-bottom: 60px;
    box-sizing: border-box;
    position: relative;
`;

export const NavigationButtonsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0;
    width: 100%;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 10px;
`;

export const Column = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 200px;
    margin: 0 5px 5px 5px;
`;

export const Fieldset = styled.fieldset`
    border: none;
    padding: 0;
`;

export const FormPartTitle = styled.div`
    font-weight: 700;
    font-size: 12px;
`;

export const DeleteCodeContainer = styled.div<{disabled?: boolean}>`
    padding: 5px;
    cursor: pointer;
    ${({disabled}) =>
        disabled &&
        css`
            pointer-events: none;
            cursor: default;
            opacity: 0.3;
        `}
`;

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const ControlContainer = styled.div`
    display: flex;
    gap: 16px;

    & > button {
        min-width: 160px;
        white-space: nowrap;

        & > span {
            display: flex;
            gap: 8px;
            align-items: center;
        }
    }
`;

export const ActionsContainer = styled.div`
    display: flex;
    gap: 12px;
    justify-content: center;

    & > * {
        cursor: pointer;
    }
`;

export const NoCodesContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    margin-top: 30px;

    & > h3 {
        margin: 0;
        font-weight: 700;
        text-transform: uppercase;
    }
`;

export const CountContainer = styled.div`
    display: grid;
    place-content: center;
    font-size: 12px;
    color: ${colors.brandPrimary};
    background-color: ${colors.brandLight};
    border-radius: 50%;
    min-width: 24px;
    margin-left: 5px;
`;

export const StepNavigationContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

export const HeadContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;
